import get from 'lodash/get';
import { getParameterByName } from '@xmatters/common/utils/string';
import * as actions from 'actions/whosOnDuty';

import { scrollAndLoadHelper } from '../reducerUtils';

export const defaultState = {
  reportStatus: 'NOT_LOADED',
  shifts: [],
  totalShifts: 0,
  err: {},
};

export default function whosOnDutyReducer(state = {}, action) {
  const { type, instanceId, payload, shiftIdFilter } = action;
  switch (type) {
    case actions.RESET_ALL:
      return {};
    case actions.RESET_INSTANCE:
      return {
        ...state,
        [instanceId]: {
          ...defaultState,
        },
      };
    case actions.LOAD_START:
      return {
        ...state,
        [instanceId]: {
          ...defaultState,
          reportStatus: 'LOADING',
        },
      };
    case actions.LOAD_SUCCESS:
    case actions.LOAD_MORE_SUCCESS: {
      const offset = parseInt(
        getParameterByName('offset', payload.links.self),
        10,
      );
      // Handled uninitialized cases
      const currentInstanceShifts = !state[instanceId]
        ? []
        : state[instanceId].shifts;
      const newInstanceShifts = scrollAndLoadHelper(
        offset,
        currentInstanceShifts,
        payload,
      );

      return {
        ...state,
        [instanceId]: {
          ...state[instanceId],
          shifts: newInstanceShifts,
          totalShifts: payload.total,
          reportStatus: 'LOADED',
        },
      };
    }
    case actions.LOAD_FAIL:
      return {
        ...state,
        [instanceId]: {
          ...state[instanceId],
          reportStatus: get(payload, 'code') === 403 ? 'FORBIDDEN' : 'FAILED',
          err: payload,
        },
      };
    case actions.LOAD_SHIFT_SUCCESS: {
      const filteredShifts = payload.data.filter(
        ({ shift }) => shift && shiftIdFilter === shift.id,
      );
      return {
        ...state,
        [instanceId]: {
          ...state[instanceId],
          shifts: filteredShifts,
          totalShifts: filteredShifts.length,
          reportStatus: 'LOADED',
        },
      };
    }
    case actions.LOAD_SHIFT_FAIL:
      return {
        ...state,
        [instanceId]: {
          ...defaultState,
          reportStatus: 'FAILED',
        },
      };
    default:
      return state;
  }
}
